<script>
import { Event, Place } from '@/api'
import PageFormBase from '@/crudBases/form/PageFormBase'
import fields from '@/components/fields/'
import moment from 'moment'

export default {
  mixins: [PageFormBase],
  data() {
    return {
      form: {
        widgets: [],
        dates: []
      },
      redirectRoute: { name: 'Event List' },
      livePreview: true
    }
  },
  mounted() {
    if (!this.form.id) {
      this.$set(this.form, 'type', 'concert')
    }
  },
  methods: {
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [
            this.getGeneralTab(),
            this.getDatesTab(),
            this.getWidgetsTab(),
            this.getPreviewTab(),
            this.getSEOTab()
          ]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Ogólne'
        },
        children: [
          new fields.Select({
            modelPath: [this, 'form', 'type'],
            required: true,
            clearable: false,
            label: 'Typ wydarzenia',
            options: [
              { label: 'Koncert', value: 'concert' },
              { label: 'Festiwal', value: 'festival' }
            ]
          }),
          new fields.Input({
            label: 'Tytuł',
            modelPath: [this, 'form', 'title'],
            type: 'textarea',
            multilingual: true,
            required: true,
            copyTo: {
              og_title_pl: { stripHtml: false, sameLanguage: true },
              og_title_en: { stripHtml: false, sameLanguage: true },
              meta_title_pl: { stripHtml: false, sameLanguage: true },
              meta_title_en: { stripHtml: false, sameLanguage: true }
            }
          }),
          new fields.Input({
            label: 'Lead',
            modelPath: [this, 'form', 'lead'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Image({
            label: 'Zdjęcie',
            modelPath: [this, 'form', 'image'],
            required: true,
            multilingual: true,
            copyTo: { og_image: { stripHtml: false } }
          }),
          new fields.Image({
            label: 'Miniaturka',
            modelPath: [this, 'form', 'thumbnail'],
            required: true,
            multilingual: true
          }),
          new fields.Switch({
            label: 'Ukryte',
            modelPath: [this, 'form', 'is_hidden']
          }),
          new fields.Input({
            label: 'Zewnętrzny link',
            modelPath: [this, 'form', 'external_url'],
            multilingual: true,
            condition: this.isFestival
          }),
          new fields.Link({
            label: 'Link do kup bilet',
            modelPath: [this, 'form', 'buy_ticket_link'],
            labelPlaceholder: 'Tekst wyświetlany na przycisku'
          })
        ]
      }
    },
    getDatesTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Daty'
        },
        children: [this.getDatesFormset()]
      }
    },
    getWidgetsTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Widgety'
        },
        children: [new fields.Widgets({ modelPath: [this, 'form', 'widgets'] })]
      }
    },
    getSEOTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'SEO'
        },
        children: [
          new fields.Input({
            label: 'Slug',
            modelPath: [this, 'form', 'slug'],
            multilingual: true,
            condition: !!this.form.id
          }),
          new fields.Input({
            label: 'Tytuł dla facebooka',
            modelPath: [this, 'form', 'og_title'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Opis dla facebooka',
            modelPath: [this, 'form', 'og_description'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Image({
            label: 'Zdjęcie dla facebooka',
            modelPath: [this, 'form', 'og_image']
          }),
          new fields.Input({
            label: 'Opis dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_description'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Input({
            label: 'Tytuł strony dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_title'],
            multilingual: true
          })
        ]
      }
    },
    getDatesFormset() {
      return new fields.Formset({
        modelPath: [this, 'form', 'dates'],
        items: this.form.dates.map((item, i) => {
          return {
            headerLabel: moment(item.date).format('YYYY-MM-DD'),
            fields: [
              new fields.ForeignKey({
                label: 'Miejsce',
                modelPath: [this, 'form', 'dates', i, 'place'],
                labelField: 'name_pl',
                valueField: 'id',
                clearable: true,
                service: Place
              }),
              new fields.Date({
                label: `Data${this.isFestival ? ' od' : ''}`,
                format: 'yyyy-MM-dd',
                valueFormat: 'yyyy-MM-dd',
                modelPath: [this, 'form', 'dates', i, 'date'],
                type: 'date',
                required: true
              }),
              new fields.Date({
                label: 'Data do',
                format: 'yyyy-MM-dd',
                valueFormat: 'yyyy-MM-dd',
                modelPath: [this, 'form', 'dates', i, 'date_to'],
                type: 'date',
                condition: this.isFestival
              }),
              new fields.WYSIWYG({
                label: 'Godzina',
                modelPath: [this, 'form', 'dates', i, 'time'],
                multilingual: true
              }),
              new fields.Input({
                label: 'Cena biletu',
                modelPath: [this, 'form', 'dates', i, 'ticket_price'],
                multilingual: true
              }),
              new fields.Switch({
                label: 'Bilety dostępne',
                modelPath: [this, 'form', 'dates', i, 'tickets_available']
              }),
              new fields.Input({
                label: 'Link do biletów',
                modelPath: [this, 'form', 'dates', i, 'ticket_url']
              }),
              new fields.Switch({
                label: 'Wydarzenie przełożone',
                modelPath: [this, 'form', 'dates', i, 'is_postponed']
              }),
              new fields.Input({
                label: 'Status',
                modelPath: [this, 'form', 'dates', i, 'status'],
                multilingual: true
              }),
              new fields.Color({
                label: 'Kolor statusu',
                modelPath: [this, 'form', 'dates', i, 'status_color']
              }),
              new fields.Switch({
                label: 'Pusty blok obok',
                modelPath: [this, 'form', 'dates', i, 'is_next_empty']
              })
            ]
          }
        })
      })
    }
  },
  computed: {
    service() {
      return Event
    },
    currentLanguage() {
      return this.$store.state.selectedLanguage
    },
    livePreviewUrl() {
      return '/preview/events/'
    },
    isFestival() {
      return this.form.type === 'festival'
    }
  }
}
</script>
